/* eslint-disable */
import React, { useMemo, useState } from 'react';

import { APPOINTMENTS, TASKS } from './constants';
import { daysUntil, groupAppointmentsByDate, overallReadiness, sortAppointmentsByDate } from './helpers';
import CareOrchestrationHeader from './components/CareOrchestrationHeader';
import ReadinessView from './components/ReadinessView';
import TasksView from './components/TasksView';

export default function MindspanCareOrchestration() {
  const [view, setView] = useState('readiness');
  const [activeTeam, setActiveTeam] = useState('all');
  const [pathwayFilter, setPathwayFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('open');
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedAppt, setSelectedAppt] = useState(null);
  const [taskFromReadiness, setTaskFromReadiness] = useState(null);

  const sortedAppts = useMemo(() => sortAppointmentsByDate(), []);
  const apptsByDate = useMemo(() => groupAppointmentsByDate(sortedAppts), [sortedAppts]);

  const readinessStats = useMemo(() => {
    const readiness = { green: 0, yellow: 0, red: 0 };
    APPOINTMENTS.forEach((appointment) => {
      readiness[overallReadiness(appointment.readiness)] += 1;
    });
    return readiness;
  }, []);

  const filtered = useMemo(
    () =>
      TASKS.filter((task) => {
        if (activeTeam !== 'all' && task.team !== activeTeam) return false;
        if (pathwayFilter !== 'all' && task.pathway !== pathwayFilter) return false;
        if (statusFilter === 'open' && task.status === 'done') return false;
        if (statusFilter === 'critical' && task.priority !== 'critical') return false;
        if (statusFilter === 'blocked' && task.status !== 'blocked' && task.status !== 'flagged')
          return false;
        return true;
      }).sort((a, b) => {
        const priority = { critical: 0, high: 1, medium: 2, low: 3 };
        return daysUntil(a.due) - daysUntil(b.due) || priority[a.priority] - priority[b.priority];
      }),
    [activeTeam, pathwayFilter, statusFilter],
  );

  const stats = useMemo(
    () => ({
      total: TASKS.filter((task) => task.status !== 'done').length,
      member: TASKS.filter((task) => task.team === 'member' && task.status !== 'done').length,
      ops: TASKS.filter((task) => task.team === 'ops' && task.status !== 'done').length,
      clinical: TASKS.filter((task) => task.team === 'clinical' && task.status !== 'done').length,
      critical: TASKS.filter((task) => task.priority === 'critical' && task.status !== 'done').length,
      blocked: TASKS.filter((task) => task.status === 'blocked' || task.status === 'flagged').length,
    }),
    [],
  );

  return (
    <div
      style={{
        fontFamily: "'IBM Plex Sans', -apple-system, sans-serif",
        background: '#FAFAFA',
        minHeight: '100vh',
        color: '#18181B',
      }}
    >
      <link
        href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500;600&display=swap"
        rel="stylesheet"
      />
      <style>{`* { box-sizing: border-box; } ::-webkit-scrollbar { width: 6px; } ::-webkit-scrollbar-track { background: transparent; } ::-webkit-scrollbar-thumb { background: #D4D4D8; border-radius: 3px; }`}</style>

      <CareOrchestrationHeader
        view={view}
        readinessStats={readinessStats}
        stats={stats}
        onChangeView={setView}
        onClearSelections={() => {
          setSelectedTask(null);
          setSelectedAppt(null);
          setTaskFromReadiness(null);
        }}
      />

      <div style={{ maxWidth: 1400, margin: '0 auto', padding: '16px 20px' }}>
        {view === 'readiness' && (
          <ReadinessView
            apptsByDate={apptsByDate}
            readinessStats={readinessStats}
            selectedAppt={selectedAppt}
            taskFromReadiness={taskFromReadiness}
            setSelectedAppt={setSelectedAppt}
            setTaskFromReadiness={setTaskFromReadiness}
          />
        )}

        {view === 'tasks' && (
          <TasksView
            activeTeam={activeTeam}
            setActiveTeam={setActiveTeam}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            stats={stats}
            filtered={filtered}
            selectedTask={selectedTask}
            setSelectedTask={setSelectedTask}
          />
        )}
      </div>
    </div>
  );
}
